import { type Transition } from 'motion/react'

export const CART_LAYOUT_TRANSITION: Transition = {
  duration: 0.25,
  ease: [0.645, 0.045, 0.355, 1],
}

export const CART_ENTER_TRANSITION: Transition = {
  duration: 0.22,
  ease: [0.215, 0.61, 0.355, 1],
}

export const CART_EXIT_TRANSITION: Transition = {
  duration: 0.18,
  ease: [0.215, 0.61, 0.355, 1],
}
